import React from 'react';
export class ProfileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
        this.listRef = React.createRef();
        this.handleClick = () => {
            this.setState({ folded: !this.state.folded });
        };
        this.handleMouseClick = (event) => {
            var _a, _b;
            if ((_a = this.listRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
                this.setState({ folded: true });
                event.target.click();
            }
            else if (!((_b = this.buttonRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target))) {
                this.setState({ folded: true });
            }
        };
        this.render = () => {
            const animationStyle = this.state.folded ? 'animate-fade-out' : 'animate-fade-in';
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'relative', style: this.props.style },
                    React.createElement("span", { className: 'mr-2 text-base-100 font-bold' }, this.props.label),
                    React.createElement("button", { ref: this.buttonRef, onClick: this.handleClick, className: 'align-middle p-0.5 rounded-full border-2 rounded border-primary-500 focus:shadow-primary-600 focus:outline-none' },
                        React.createElement("img", { className: 'object-cover w-8 h-8 rounded-full', src: this.props.image })),
                    React.createElement("ul", { ref: this.listRef, className: `absolute right-0 w-56 mt-2 text-base-300 bg-base-800 border rounded-md border-base-700 shadow-md animation-duration-300 animation-fill-forwards ${animationStyle}` }, this.props.children))));
        };
        this.state = { folded: true };
        this.handleMouseClick = this.handleMouseClick.bind(this);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleMouseClick);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleMouseClick);
    }
}
